import { createFileRoute, Link } from '@tanstack/react-router'
import { RequireAuth } from '../auth/RequireAuth'
import { InvitationScreen } from '../features/membership/InvitationScreen'

interface InvitationSearch {
  readonly token?: string
  readonly workspace_id?: string
}

function validateSearch(search: Record<string, unknown>): InvitationSearch {
  const parsed: { token?: string; workspace_id?: string } = {}
  if (typeof search.token === 'string' && search.token.trim() !== '')
    parsed.token = search.token
  if (typeof search.workspace_id === 'string' && search.workspace_id.trim() !== '')
    parsed.workspace_id = search.workspace_id
  return parsed
}

function InvitationAccept() {
  const { token: pathToken } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const token = search.token ?? (pathToken === 'accept' ? undefined : pathToken)
  const workspaceId = search.workspace_id

  if (token === undefined || workspaceId === undefined) {
    return (
      <main className="mx-auto max-w-xl space-y-4 p-6 text-foreground">
        <h1 className="font-heading text-2xl font-semibold">Invalid invitation link</h1>
        <p className="text-sm text-muted-foreground">
          This link is missing the workspace or invitation token. Ask the workspace owner for a
          new invitation.
        </p>
        <Link
          to="/"
          className="rounded-md text-primary underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        >
          Go to Argus
        </Link>
      </main>
    )
  }

  return (
    <RequireAuth>
      <main className="mx-auto max-w-xl p-6">
        <InvitationScreen
          workspaceId={workspaceId}
          token={token}
          onAccepted={() => {
            void navigate({ to: '/w/$workspaceId', params: { workspaceId } })
          }}
        />
      </main>
    </RequireAuth>
  )
}

export const Route = createFileRoute('/invitations/$token')({
  component: InvitationAccept,
  validateSearch,
})
